/* @jsxImportSource @emotion/react */

import type { HTMLAttributes } from 'react'
import React from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'

export type WebsiteCardProps = {
  children?: React.ReactNode
  type?: 'default' | 'glass' | 'gradient'
  active?: boolean
  href?: string
  highlighted?: boolean
  target?: HTMLLinkElement['target']
  hoverOutline?: boolean
} & Omit<HTMLAttributes<HTMLDivElement>, 'css'>

export const WebsiteCard = ({
  children,
  type = 'default',
  className,
  active,
  href,
  style,
  highlighted,
  target,
  hoverOutline = true,

  ...props
}: WebsiteCardProps) => {
  const hoverable = !!href

  const cardStyles = hoverOutline
    ? css`
        position: relative;

        &:before {
          display: block;
          position: absolute;
          content: '';
          border-radius: 20px;
          width: calc(100% + 12px);
          height: calc(100% + 12px);
          border: 1px solid transparent;
          transition: all 0.3s ease;
          top: -6px;
          left: -6px;
        }

        &:hover:before {
          border: 1px solid var(--shade-05);
        }
      `
    : css`
        position: relative;
      `

  const commonProps = {
    className: classNames(
      'background-white radius-semilarger',
      type,
      'transition',
      {
        active,
        highlighted,
        pointer: hoverable,
      },
      className
    ),
    css: cardStyles,
    style,
  }

  if (href) {
    return (
      <a href={href} target={target} {...commonProps}>
        {children}
      </a>
    )
  }

  return (
    <div {...props} {...commonProps}>
      {children}
    </div>
  )
}
